import React from "react";
import { Modal } from "react-bootstrap";

export default function DeleteDialog(props) {
  const handleDelete = () => {
    props.onDelete();
  };
  return (
    <Modal
      show={props.show}
      onHide={props.onClose}
      centered
      backdrop="static" // Prevent closing on overlay click
      keyboard={false}
      contentClassName="p-4"
    >
      <Modal.Header className="flex-column p-0 border-0">
        <p className="sub-step-bold mb-0">Delete Result Files</p>
      </Modal.Header>
      <Modal.Body className="mt-4 mb-4 p-0">
        <p className="text-center m-0">
          Are you sure you want to delete the result files? Once deleted, you
          cannot retrieve the file(s).
        </p>
      </Modal.Body>
      <Modal.Footer className="justify-content-center border-0 p-0">
        <div className="m-0 me-2">
          <button onClick={handleDelete} className="learnmore-btn m-0"
            style={{padding:"12px 24px"}}
          >
            Delete
          </button>
        </div>
        <div className="m-0 ms-2">
          <button onClick={props.onClose} className="cancel-btn m-0"
            style={{padding:"12px 24px"}}
          >
            Cancel
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
